import React from "react";
import LoginForm from "../components/Login/LoginForm";
const LoginPage = () => {
  return (
    <>
      <LoginForm />
    </>
  );
};

export default LoginPage;
